"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const FlightV3Svg = () => (
  <svg width="1.0625em" height="1em" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3118_45282)">
      <path d="M3.39927 4.73495L2.0933 4.73495L3.39927 7.99986L2.0933 11.2657L3.39927 11.2657L4.70569 9.30629L7.76557 9.30629L5.87497 14.5311L7.11166 14.5311L11.2369 9.30675L13.8493 9.30629C14.0227 9.3093 14.195 9.27775 14.3561 9.21347C14.5172 9.1492 14.6638 9.05348 14.7875 8.93191C14.9112 8.81034 15.0095 8.66536 15.0766 8.50541C15.1436 8.34546 15.1782 8.17376 15.1782 8.00032C15.1782 7.82689 15.1436 7.65518 15.0766 7.49524C15.0095 7.33529 14.9112 7.19031 14.7875 7.06874C14.6638 6.94717 14.5172 6.85145 14.3561 6.78717C14.195 6.7229 14.0227 6.69134 13.8493 6.69436L11.1681 6.69436L7.04332 1.46957L5.87451 1.47003L7.70969 6.69482L4.70523 6.69482L3.39927 4.73495Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_3118_45282">
        <rect width="16" height="16" fill="white" transform="translate(0.5 16) rotate(-90)" />
      </clipPath>
    </defs>
  </svg>
)

const FlightV3Icon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={FlightV3Svg} {...props} />
);

export default FlightV3Icon